import { NgModule } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DataCaptureModule } from '@techspert-io/data-capture';
import { ExpertsService } from '@techspert-io/experts';
import { FileModule } from '@techspert-io/files';
import { NotificationsModule } from '@techspert-io/notifications';
import { OmnisearchModule } from '@techspert-io/omnisearch';
import { PatternsModule } from '@techspert-io/patterns';
import { SharedExpertEmailsService } from '@techspert-io/shared-expert-emails';
import { TranscriptionModule } from '@techspert-io/transcriptions';
import { InterviewPeriodCallOverlapWarningComponent } from '../../features/interview-period/components/call-overlap-warning/interview-period-call-overlap-warning.component';
import { SharedModule } from '../../shared/shared.module';
import { ExpertSummaryDownloadDirective } from './directives/expert-export.directive';
import { ExpertListComponent } from './expert-list/expert-list.component';
import { AskExpertFollowUpQuestionsDialogComponent } from './expert-list/expert-table/dialogs/ask-expert-followup-questions/ask-expert-followup-questions-dialog.component';
import { ExpertTableComponent } from './expert-list/expert-table/expert-table.component';
import { AcceptanceWithdrawalBlockedDialogComponent } from './expert-list/expert/dialogs/acceptance-withdrawal-blocked-dialog/acceptance-withdrawal-blocked-dialog.component';
import { ExpertNoShowDialogComponent } from './expert-list/expert/dialogs/expert-no-show-dialog/expert-no-show-dialog.component';
import { ExpertTranscriptDialogComponent } from './expert-list/expert/dialogs/expert-transcript-dialog/expert-transcript-dialog.component';
import { OnHoldReasonDialogComponent } from './expert-list/expert/dialogs/reason-for-on-hold/on-hold-reason-dialog.component';
import { ReasonRejectionDialogComponent } from './expert-list/expert/dialogs/reason-for-rejection/rejection-reason-dialog.component';
import { RequestAdditionalAvailabilityComponent } from './expert-list/expert/dialogs/request-additional-availability/request-additional-availability.component';
import { RequestConferenceDialogComponent } from './expert-list/expert/dialogs/request-conference-dialog/request-conference-dialog.component';
import { RequestExpertEngagementComponent } from './expert-list/expert/dialogs/request-expert-engagement/request-expert-engagement.component';
import { SelectAvailabilityDialogComponent } from './expert-list/expert/dialogs/select-availability-dialog/select-availability-dialog.component';
import { ShareExpertDialogComponent } from './expert-list/expert/dialogs/share-expert/share-expert-dialog.component';
import { ExpertAvailabilityComponent } from './expert-list/expert/expert-availability/expert-availability.component';
import { ExpertExpandAllToggleComponent } from './expert-list/expert/expert-expand-all-toggle/expert-expand-all-toggle.component';
import { ExpertFilterComponent } from './expert-list/expert/expert-filter/expert-filter.component';
import { ExpertHexagonComponent } from './expert-list/expert/expert-hexagon/expert-hexagon.component';
import { ExpertScreenerBtnComponent } from './expert-list/expert/expert-screener-btn/expert-screener-btn.component';
import { ExpertTextComponent } from './expert-list/expert/expert-text/expert-text.component';
import { ExpertTimelineComponent } from './expert-list/expert/expert-timeline/expert-timeline.component';
import { ExpertUnitComponent } from './expert-list/expert/expert-unit/expert-unit.component';
import { ExpertComponent } from './expert-list/expert/expert.component';
import { OnHoldSvgComponent } from './expert-list/on-hold-svg/on-hold-svg.component';
import { ApprovalTooltipPipe } from './expert-list/pipes/approval-tooltip.pipe';
import { ExpertListValuePipe } from './expert-list/pipes/expert-list-value.pipe';
import { GeographicProgressComponent } from './geographic-progress/geographic-progress.component';
import { EmptyStateComplianceSvgComponent } from './images/empty-state-svg.component';
import { OpportunityComponent } from './opportunity.component';
import { RemoveIndentPipe } from './pipes/remove-indent.pipe';
import { WorksheetService } from './services/worksheet.service';

@NgModule({
  declarations: [
    AcceptanceWithdrawalBlockedDialogComponent,
    ApprovalTooltipPipe,
    AskExpertFollowUpQuestionsDialogComponent,
    EmptyStateComplianceSvgComponent,
    ExpertComponent,
    ExpertExpandAllToggleComponent,
    ExpertFilterComponent,
    ExpertHexagonComponent,
    ExpertListComponent,
    ExpertListValuePipe,
    ExpertNoShowDialogComponent,
    ExpertScreenerBtnComponent,
    ExpertSummaryDownloadDirective,
    ExpertTableComponent,
    ExpertTextComponent,
    ExpertTranscriptDialogComponent,
    ExpertTimelineComponent,
    ExpertUnitComponent,
    GeographicProgressComponent,
    OnHoldReasonDialogComponent,
    OnHoldSvgComponent,
    OpportunityComponent,
    ReasonRejectionDialogComponent,
    RemoveIndentPipe,
    RequestConferenceDialogComponent,
    RequestExpertEngagementComponent,
    SelectAvailabilityDialogComponent,
    ShareExpertDialogComponent,
  ],
  providers: [WorksheetService, ExpertsService, SharedExpertEmailsService],
  imports: [
    DataCaptureModule,
    FileModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    NotificationsModule,
    OmnisearchModule,
    TranscriptionModule,
    PatternsModule,
    SharedModule,
    MatBadge,
    RequestAdditionalAvailabilityComponent,
    MatDividerModule,
    ExpertAvailabilityComponent,
    InterviewPeriodCallOverlapWarningComponent,
  ],
  exports: [
    AcceptanceWithdrawalBlockedDialogComponent,
    AskExpertFollowUpQuestionsDialogComponent,
    DataCaptureModule,
    ExpertComponent,
    ExpertListComponent,
    ExpertNoShowDialogComponent,
    ExpertTextComponent,
    GeographicProgressComponent,
    OnHoldReasonDialogComponent,
    OpportunityComponent,
    ReasonRejectionDialogComponent,
    RequestExpertEngagementComponent,
    RequestAdditionalAvailabilityComponent,
    SelectAvailabilityDialogComponent,
    ShareExpertDialogComponent,
  ],
})
export class OpportunityModule {}
